import { isPerformingSubmitActionSelector, performingSubmitActionErrorSelector, performingSubmitActionResultSelector, submitCreateActionCreator, } from "./schema.createTask.actions";
import { formList } from "./schema.createTask.list";
export var createTaskForm = {
    formList: formList,
    submitCreateActionCreator: submitCreateActionCreator,
    isPerformingSubmitActionSelector: isPerformingSubmitActionSelector,
    performingSubmitActionResultSelector: performingSubmitActionResultSelector,
    performingSubmitActionErrorSelector: performingSubmitActionErrorSelector,
};
